/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventDeviceRoomResponseDto } from './EventDeviceRoomResponseDto';
import type { EventDeviceTenantResponseDto } from './EventDeviceTenantResponseDto';
export type EventDeviceResponseDto = {
  /**
   * Unique serial number of the device.
   */
  serialNumber: string;
  /**
   * Device type.
   */
  type: string;
  /**
   * Current status of the device.
   */
  status: EventDeviceResponseDto.status;
  /**
   * Room to which the device belongs.
   */
  room?: EventDeviceRoomResponseDto;
  /**
   * Tenant to which the device belongs.
   */
  tenant?: EventDeviceTenantResponseDto;
};
export namespace EventDeviceResponseDto {
  /**
   * Current status of the device.
   */
  export enum status {
    NEW = 'NEW',
    NEW_IN_PROGRESS = 'NEW_IN_PROGRESS',
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    FOR_RETURN = 'FOR_RETURN',
    FOR_RETURN_IN_PROGRESS = 'FOR_RETURN_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
}

